import { ResearchHeader, ProjectCard } from "./components";
import { useState } from "react";
import { projects } from "../../constants/researchLines/projects";


const filterCategories = ["Todos", "Sistemas Embebidos", "Materiales Inteligentes", "IA & Control"];

export default function ResearchProjects() {
  const [activeFilter, setActiveFilter] = useState("Todos");
  const [search, setSearch] = useState("");

  const filtered = projects.filter((p) => {
    const matchSearch = search === "" || p.titleText.toLowerCase().includes(search.toLowerCase());
    const matchFilter = activeFilter === "Todos" || p.category.toLowerCase().includes(activeFilter.toLowerCase());
    return matchSearch && matchFilter;
  });

  return (
    <div className="min-h-screen" style={{
      background: "linear-gradient(135deg, #f0f4f8 0%, #e8edf5 50%, #f0f4f8 100%)"
    }}>
      <ResearchHeader />

      {/* Filter bar */}
      <div className="sticky top-0 bg-white border-b border-gray-200 z-10 shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row gap-4 items-center">
          <div className="relative flex-1 max-w-sm">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Filtrar por tecnología o nombre..."
              className="w-full border border-gray-300 rounded px-4 py-2 text-mini pr-10 focus:outline-none focus:border-dorado-uady"
            />
            <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" strokeLinecap="round" />
            </svg>
          </div>
          <div className="flex gap-2 flex-wrap">
            {filterCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`text-mini px-4 py-2 rounded font-medium transition-colors ${activeFilter === cat
                    ? "bg-dorado-uady text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Project grid */}
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {filtered.map((project) => (
            <ProjectCard {...project} />
          ))}
        </div>

        {/* Stats footer */}
        <div className="mt-12 bg-white rounded-xl border border-gray-100 shadow-sm p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center">
            <p className="text-4xl font-bold text-dorado-uady">15+</p>
            <p className="text-micro text-gray-400 uppercase tracking-wider font-semibold mt-1">PROYECTOS ACTIVOS</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-dorado-uady">38</p>
            <p className="text-micro text-gray-400 uppercase tracking-wider font-semibold mt-1">ARTÍCULOS JCR</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-dorado-uady">03</p>
            <p className="text-micro text-gray-400 uppercase tracking-wider font-semibold mt-1">PATENTES REGISTRADAS</p>
          </div>
          <a href="/contactUs" className="bg-dorado-uady text-white font-semibold text-mini px-8 py-3 rounded hover:bg-yellow-600 transition-colors">
            COLABORAR CON NOSOTROS
          </a>
        </div>
      </div>
    </div>
  );
}
